import { render, staticRenderFns } from "./EmailVerifPage.vue?vue&type=template&id=451ecbeb&scoped=true"
import script from "./EmailVerifPage.vue?vue&type=script&lang=js"
export * from "./EmailVerifPage.vue?vue&type=script&lang=js"
import style0 from "./EmailVerifPage.vue?vue&type=style&index=0&id=451ecbeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ecbeb",
  null
  
)

export default component.exports